import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { getCollaboratorProfileHref } from '../../../vacations.definitions';

interface CollaboratorNameLinkProps {
    collaboratorId: string;
    name: string;
    className?: string;
}

export function CollaboratorNameLink({ collaboratorId, name, className }: CollaboratorNameLinkProps) {
    return (
        <Link
            to={getCollaboratorProfileHref(collaboratorId)}
            className={clsx('underline-offset-2 transition-colors hover:text-primary-700 hover:underline', className)}
        >
            {name}
        </Link>
    );
}

export default CollaboratorNameLink;
